export const USER_GCAL_CALENDARS_LIST = 'USER_GCAL_CALENDARS_LIST'

export const SCHEDULE_START_SYNCING_EVENT = 'SCHEDULE_START_SYNCING_EVENT'
export const SCHEDULE_STOP_SYNCING_EVENT = 'SCHEDULE_STOP_SYNCING_EVENT'

export const SCHEDULE_START_SYNCING_CALENDAR = 'SCHEDULE_START_SYNCING_CALENDAR'
export const SCHEDULE_STOP_SYNCING_CALENDAR = 'SCHEDULE_STOP_SYNCING_CALENDAR'



// WEBPACK FOOTER //
// ./src/infra/actions/types.js